import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ko from 'vuetify/src/locale/ko.ts'
import colors from '@/assets/scss/common/_variables.scss'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  breakpoint: {
    scrollBarWidth: 6,
    mobileBreakpoint: 769, // 768부터 모바일로 본다
  },
  theme: {
    themes: {
      light: {
        primary: colors['main-color-default'],
        error: colors['red'],
        green: colors['green'],
        pink: colors['pink'],
        accent: colors['navy'],
      },
    },
  },
  lang: {
    locales: { ko },
    current: 'ko',
  },
})
